$(function() {
  $(".year_blk").addClass("active");

  var sortList = window.matchMedia('screen and (min-width: 1025px)');
  function checkBreakPoint(sortList) {
    //タブレット向け
    if (!sortList.matches) {
      $(".sort_pc .sort_trigger a").on('click',function(){
        $(this).parents(".sort_pc").find(".sort_content").slideToggle(200);
        $(this).toggleClass("open");
      });
      $(".sort_pc .sort_content li a").on('click',function(){
        $(".sort_pc .sort_content").slideUp(200);
        $(".sort_pc .sort_trigger a").removeClass("open");
      });
    }
    //PC向け
    else {
      $(".sort_pc").hover(function() {
        $(this).find(".sort_content").slideDown(200);
        $(this).find(".sort_trigger a").addClass("open");
      }, function() {
        $(this).find(".sort_content").slideUp(100);
        $(this).find(".sort_trigger a").removeClass("open");
      });
    }
  }
  // ブレイクポイントの瞬間に発火
  sortList.addListener(checkBreakPoint);
  // 初回の実行
  checkBreakPoint(sortList);

  $('.sort_pc .sort_content li a:not(.view_all)').each(function(){
    $(this).on('click',function(){
      if($(this).hasClass('active')){
        var cls_name = $(this).attr("class");
        $(this).removeClass('active');
        $("#" + cls_name).removeClass("active");
      } else {
        var cls_name = $(this).attr("class");
        $('.sort_pc .sort_content li a').removeClass('active');
        $('.year_blk').removeClass('active');
        $(this).addClass("active");
        $("#" + cls_name).addClass("active");
      }
    });
  });
  $(".sort_pc .sort_content li .view_all").on('click',function(){
    $('.sort_pc .sort_content li a').removeClass('active');
    $(this).addClass('active');
    $('.year_blk').addClass('active');
  });

  $(".sort_sp .sort_content").change(function() {
    var value_name = $(this).val();
    if(value_name == "select_year"){
    } else if(value_name == "view_all") {
      $('.year_blk').addClass('active');
    } else {
      $('.year_blk').removeClass('active');
      $("#" + value_name).addClass("active");
    }
  });
});